module.exports = __webpack_public_path__ + "img/DSC2165-1024x683.2702e26e.jpg";